
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ACTIVE_LANGS } from './langs';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'es-MX',
        supportedLngs: ACTIVE_LANGS.map(lang => lang.key),
        load: 'currentOnly',
        debug:
            typeof process !== 'undefined' &&
            process.env?.NODE_ENV === 'development' &&
            !process.env?.REACT_APP_I18N_DEBUG_OFF,

        interpolation: {
            escapeValue: false,
        },

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'lang',
            lookupLocalStorage: 'i18nextLng',
        },

        react: {
            useSuspense: false,
        }
    });

export default i18n;
